const CALCULATION_FINISHED_PARAM = "calculation_finished";

export function reloadWithCalculationFlash() {
  const url = new URL(window.location.href);
  url.searchParams.set(CALCULATION_FINISHED_PARAM, "1");
  window.location.assign(url.toString());
}
